import { render, staticRenderFns } from "./QuoteGridForAdmin.vue?vue&type=template&id=5906ec56"
import script from "./QuoteGridForAdmin.vue?vue&type=script&lang=js"
export * from "./QuoteGridForAdmin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports